import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DialogFrame from "@/components/DialogFrame.vue";
import {onMounted, ref} from "vue";
import {authStore} from "@/stores/auth-store";


export default /*@__PURE__*/_defineComponent({
  __name: 'StaffNotificationDialog',
  setup(__props) {


const show = ref<boolean>(false)

onMounted(() => {

    // このコメントアウトを解除すると1回限りの表示となります。
    // if (!authStore.state.staffNotificationShowed) {
    //     show.value = true
    //     authStore.commit("updateStaffNotificationShowed", true)
    // }

    // こちらが有効だと毎回表示
    show.value = false
})

const onClickClose = () => {
    show.value = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogFrame, {
    "on-click-close": onClickClose,
    title: "お知らせ",
    "show-dialog": show.value
  }, {
    dialogContent: _withCtx(() => [
      _createElementVNode("div", { class: "container-fluid h-100 pt-4" }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row note-row" }, [
          _createElementVNode("div", { class: "col" }, "８月２２日、アト前払いシステムでエラーが発生し、誤った金額の振込手続きがされていることが判明しました。 ご迷惑をお掛けしましたこと、心より深くお詫び申し上げます。 具体的な誤った金額、返金方法に関して、メールにてご連絡を差し上げました。 ご確認の程、宜しくお願い申し上げます。 株式会社マス・コア")
        ], -1)),
        _createElementVNode("div", { class: "row justify-content-center button-row" }, [
          _createElementVNode("button", {
            class: "btn btn-info w-100",
            onClick: onClickClose
          }, "OK")
        ])
      ])
    ]),
    _: 1
  }, 8, ["show-dialog"]))
}
}

})